import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Button from '@mui/material/Button';
import Icon from '@mui/material/Icon';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';

import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import LoadingRing from '@Components/MuiWrappers/LoadingRing';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import { useEffect, useState } from 'react';

const EmployeeListingFeaturedDomain = (props) => {
    const {
        listingId,
        targetSite,
        topLevelDomain
    } = props;

    const [showTable, setShowTable] = useState(false);
    const [isLoaded, setLoaded] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [featuredDomains, setFeaturedDomains] = useState([]);
    const routes = useRecoilValue(atoms.routes);

    useEffect(() => {
        setLoading(true);
        sandhillsRequest({
            method: 'post',
            url: routes.GetSiteFeaturedDomainByListingID,
            data: {
                ListingID: listingId,
                TargetSite: targetSite,
                TopLevelDomain: topLevelDomain
            },
            errorHandling: {
                message: 'Fatal Error',
                showDetails: true,
                useConsole: true,
                useAlert: false
            }
        })
            .then((response) => {
                if (response) {
                    setFeaturedDomains(response);
                } else {
                    console.error("Failure", response);
                }
            })
            .finally(() => {
                setLoaded(true);
                setLoading(false);
            });
    }, []);

    const toggleDetails = () => {
        setShowTable(prevState => !prevState);
    };

    // Still loading the initial data
    if (!isLoaded) {
        return isLoading ? <LoadingRing backdrop /> : null;
    }

    // Loaded but nothing to show -> hide the entire view
    if (!featuredDomains || featuredDomains.length === 0) {
        return null;
    }

    return (
            <Box pb={1}>
                <Button variant='contained' size='small' onClick={toggleDetails}>
                    <Icon baseClassName="fas" className={showTable ? 'fa-caret-down' : 'fa-caret-right'} />
                    {!showTable ? 'Show' : 'Hide'} Featured Domains
                </Button>
                {showTable &&
                    <Box pt={1}>
                        <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
                            <Table size="small" stickyHeader>
                                <TableBody>
                                    <TableRow>
                                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={3}>
                                            <Collapse in={open} timeout="auto" unmountOnExit>
                                                <Box sx={{ margin: 1 }}>
                                                    <>
                                                        <br />
                                                        <Typography variant="h6" gutterBottom component="div">
                                                            Featured Domains
                                                        </Typography>
                                                        <Table size="small" aria-label="Featured Domains">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>ID</TableCell>
                                                                    <TableCell>Publication Type ID</TableCell>
                                                                    <TableCell>Publication Type</TableCell>
                                                                    <TableCell>Edition Type ID</TableCell>
                                                                    <TableCell>Edition Type</TableCell>
                                                                    <TableCell>Ad Type</TableCell>
                                                                    <TableCell>Sort Ranking ID</TableCell>
                                                                    <TableCell>Item Types</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {featuredDomains?.map((featuredDomain) => (
                                                                    <TableRow key={`${featuredDomain.PublicationTypeID}-${featuredDomain.EditionTypeID}`}>
                                                                        <TableCell>{featuredDomain.FeaturedListingID}</TableCell>
                                                                        <TableCell>{featuredDomain.PublicationTypeID}</TableCell>
                                                                        <TableCell>{featuredDomain.PublicationType}</TableCell>
                                                                        <TableCell>{featuredDomain.EditionTypeID}</TableCell>
                                                                        <TableCell>{featuredDomain.EditionType}</TableCell>
                                                                        <TableCell>{featuredDomain.AdType}</TableCell>
                                                                        <TableCell>{featuredDomain.FeaturedListingSortID}</TableCell>
                                                                        <TableCell>
                                                                            {(featuredDomain.ItemTypes || []).join(', ')}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </>
                                                </Box>
                                            </Collapse>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                }
            </Box>
    );
};

export default EmployeeListingFeaturedDomain;